// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactSupportModal__ydBaI {
  width: 720px;
  height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 850px) {
  .contactSupportModal__ydBaI {
    width: 600px;
    height: 475px;
  }
}

.modalBody__Km2t4 {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 25px;
  gap: 15px;
}

.modalFooter__jJIeP {
  margin-top: 15px;
  padding: 0 25px 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}

.personalInformationContainer__CQFIL {
  display: grid;
  gap: 25px;
  grid-template-columns: 1fr 1fr;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/ContactSupportModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;AA2EE;EAPF;IAQI,YAAA;IACA,aAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.contactSupportModal {\n  width: 720px;\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (max-width: 850px) {\n    width: 600px;\n    height: 475px;\n  }\n}\n\n.modalBody {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 25px;\n  gap: 15px;\n}\n\n.modalFooter {\n  margin-top: 15px;\n  padding: 0 25px 25px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}\n\n.personalInformationContainer {\n  display: grid;\n  gap: 25px;\n  grid-template-columns: 1fr 1fr;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactSupportModal": `contactSupportModal__ydBaI`,
	"modalBody": `modalBody__Km2t4`,
	"modalFooter": `modalFooter__jJIeP`,
	"personalInformationContainer": `personalInformationContainer__CQFIL`
};
module.exports = ___CSS_LOADER_EXPORT___;
